import { Box, Flex, Text } from '@chakra-ui/react';
import { NovaIconButton } from 'components/ui/NovaIconButton';
import { ReactElement, cloneElement } from 'react';
import { NavLink } from 'react-router-dom';
import { NavigationLinkProps } from 'types/NavigationBarDesktop';

export const NavigationLink = ({
  to,
  iconInactive,
  iconActive,
  isActive,
  title,
  hasTitle: _hasTitle,
}: NavigationLinkProps): ReactElement => {
  const textColor = isActive ? 'text.accent' : 'text.quaternary';
  const boxBg = isActive ? 'background.accent' : 'background.primary';
  const Glyph = isActive && iconActive != null ? iconActive : iconInactive;
  return (
    <NavLink to={to} style={{ width: '20%', backgroundColor: 'background.primary' }}>
      <Flex
        direction="column"
        justifyContent="flex-start"
        alignItems="center"
        _active={{ bg: 'background.primary' }}
      >
        <Box bg={boxBg} h="3px" w="75%" borderRadius="5px" />
        <NovaIconButton
          variant="primary"
          size="l"
          aria-label={title}
          color={textColor}
          transition="all 0.1s ease-in"
          w="40px"
          h="40px"
          borderRadius="xl"
          _active={{ bg: 'background.primary' }}
          _pressed={{ bg: 'background.primary' }}
          _focus={{ bg: 'background.primary', outline: 'none' }}
          _focusVisible={{ outline: 'none' }}
        >
          {cloneElement(Glyph, { ...Glyph.props, w: '22px', h: '22px', color: textColor })}
        </NovaIconButton>
        <Text color={textColor} marginTop="-5px">
          {title}
        </Text>
      </Flex>
    </NavLink>
  );
};
